export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  itemCount: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '热门推荐',
    slug: 'recommended',
    description: '精选全网热门影视内容，每日更新推荐榜单',
    icon: 'ri-fire-line',
    itemCount: 128,
  },
  {
    id: 'cat-2',
    name: '最新上映',
    slug: 'latest',
    description: '院线大片、网络新片第一时间同步更新',
    icon: 'ri-film-line',
    itemCount: 96,
  },
  {
    id: 'cat-3',
    name: '国产剧集',
    slug: 'domestic',
    description: '热门国产电视剧、网剧全网同步追更',
    icon: 'ri-tv-2-line',
    itemCount: 256,
  },
  {
    id: 'cat-4',
    name: '海外剧集',
    slug: 'overseas',
    description: '美剧、韩剧、日剧等海外优质剧集一网打尽',
    icon: 'ri-global-line',
    itemCount: 312,
  },
  {
    id: 'cat-5',
    name: '综艺娱乐',
    slug: 'variety',
    description: '热门综艺、脱口秀、真人秀精彩不停',
    icon: 'ri-emotion-laugh-line',
    itemCount: 88,
  },
  {
    id: 'cat-6',
    name: '动漫番剧',
    slug: 'anime',
    description: '日漫、国漫、剧场版动画应有尽有',
    icon: 'ri-ghost-line',
    itemCount: 200,
  },
  {
    id: 'cat-7',
    name: '纪录片',
    slug: 'documentary',
    description: 'BBC、国家地理等精品纪录片汇聚',
    icon: 'ri-camera-lens-line',
    itemCount: 64,
  },
  {
    id: 'cat-8',
    name: '少儿频道',
    slug: 'kids',
    description: '优质儿童动画、教育内容，陪伴孩子成长',
    icon: 'ri-bear-smile-line',
    itemCount: 45,
  },
];

export interface CategoryItem {
  id: string;
  categoryId: string;
  title: string;
  image: string;
  rating: number;
  year: string;
  type: string;
  region: string;
  description: string;
  tags: string[];
}

export const categoryItems: CategoryItem[] = [
  {
    id: 'item-1', categoryId: 'cat-1', title: '繁花', image: '', rating: 9.3, year: '2024', type: '电视剧', region: '中国大陆', description: '王家卫导演首部电视剧，胡歌马伊琍主演，讲述上海滩三十年风云变幻', tags: ['热门', '必看'],
  },
  {
    id: 'item-2', categoryId: 'cat-1', title: '流浪地球2', image: '', rating: 9.1, year: '2023', type: '电影', region: '中国大陆', description: '吴京刘德华主演科幻巨制，人类命运共同体的史诗篇章', tags: ['科幻', 'IMAX'],
  },
  {
    id: 'item-3', categoryId: 'cat-1', title: '狂飙', image: '', rating: 9.4, year: '2023', type: '电视剧', region: '中国大陆', description: '张译张颂文主演扫黑除恶大剧，年度现象级爆款', tags: ['悬疑', '犯罪'],
  },
  {
    id: 'item-4', categoryId: 'cat-1', title: '奥本海默', image: '', rating: 8.9, year: '2023', type: '电影', region: '美国', description: '诺兰导演传记大片，原子弹之父的传奇人生', tags: ['传记', '历史'],
  },
  {
    id: 'item-5', categoryId: 'cat-2', title: '封神第二部', image: '', rating: 8.8, year: '2025', type: '电影', region: '中国大陆', description: '神话史诗续作，封神大战全面爆发', tags: ['神话', '奇幻'],
  },
  {
    id: 'item-6', categoryId: 'cat-2', title: '沙丘2', image: '', rating: 9.0, year: '2024', type: '电影', region: '美国', description: '维伦纽瓦科幻史诗续作，保罗的复仇之路', tags: ['科幻', '史诗'],
  },
  {
    id: 'item-7', categoryId: 'cat-3', title: '庆余年第二季', image: '', rating: 9.2, year: '2024', type: '电视剧', region: '中国大陆', description: '张若昀领衔古装权谋大剧，范闲归来搅动天下', tags: ['古装', '权谋'],
  },
  {
    id: 'item-8', categoryId: 'cat-3', title: '三体', image: '', rating: 8.7, year: '2023', type: '电视剧', region: '中国大陆', description: '刘慈欣科幻巨著改编，人类文明与外星文明的首次接触', tags: ['科幻', '悬疑'],
  },
  {
    id: 'item-9', categoryId: 'cat-4', title: '最后生还者', image: '', rating: 9.1, year: '2023', type: '电视剧', region: '美国', description: 'HBO出品末日生存剧，游戏改编天花板之作', tags: ['末日', '剧情'],
  },
  {
    id: 'item-10', categoryId: 'cat-4', title: '黑暗荣耀', image: '', rating: 9.0, year: '2023', type: '电视剧', region: '韩国', description: '宋慧乔主演复仇爽剧，校园暴力受害者的华丽复仇', tags: ['复仇', '悬疑'],
  },
  {
    id: 'item-11', categoryId: 'cat-5', title: '歌手2024', image: '', rating: 8.5, year: '2024', type: '综艺', region: '中国大陆', description: '顶级音乐竞演节目回归，实力唱将巅峰对决', tags: ['音乐', '竞技'],
  },
  {
    id: 'item-12', categoryId: 'cat-5', title: '乘风破浪的姐姐', image: '', rating: 8.3, year: '2024', type: '综艺', region: '中国大陆', description: '姐姐们再次集结，舞台魅力全面升级', tags: ['女团', '舞台'],
  },
  {
    id: 'item-13', categoryId: 'cat-6', title: '鬼灭之刃 柱训练篇', image: '', rating: 9.0, year: '2024', type: '动漫', region: '日本', description: '人气日漫新篇章，炭治郎迎接柱的训练考验', tags: ['热血', '战斗'],
  },
  {
    id: 'item-14', categoryId: 'cat-6', title: '哪吒之魔童闹海', image: '', rating: 9.3, year: '2025', type: '电影', region: '中国大陆', description: '国产动画电影续作，哪吒再度挑战命运', tags: ['动画', '神话'],
  },
  {
    id: 'item-15', categoryId: 'cat-7', title: '地球脉动第三季', image: '', rating: 9.7, year: '2024', type: '纪录片', region: '英国', description: 'BBC自然纪录片巅峰之作，探索地球生命奇迹', tags: ['自然', 'BBC'],
  },
  {
    id: 'item-16', categoryId: 'cat-8', title: '汪汪队立大功大电影', image: '', rating: 8.0, year: '2023', type: '电影', region: '美国', description: '小朋友最爱，汪汪队冒险再启程', tags: ['儿童', '冒险'],
  },
];